export const reportSaleByMunicipalityTypes = {
  SET_SALE_BY_MUNICIPALITY_FILTERS: 'SET_SALE_BY_MUNICIPALITY_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL'
};
